<template>
    <div ref="container">
        <div v-if="!thumbnail">
            <iframe class="rutube_embed" allowfullscreen loading="lazy" :src="video"></iframe>
        </div>
        <div v-else class="rutube_embed__container relative" :style="'min-height: ' + getThumbnailHeight + 'px'">
            <div v-if="isShowVideo" class="pt-1 pb-2" style="margin-bottom: 1px">
                <AdaptersLoader :loading="iframeLoading" background="transparent" />
                <iframe
                    v-if="imageLoaded"
                    :src="video"
                    :height="getThumbnailHeight"
                    :width="getThumbnailWidth"
                    frameBorder="0"
                    allowFullScreen
                    allow="clipboard-write; autoplay"
                    ref="video"
                    @load="iframeLoading = false"
                ></iframe>
            </div>
            <div v-show="!isShowVideo" class="rutube_embed__thumbnail">
                <img
                    @load="onLoadThumbnail"
                    :src="thumbnail"
                    :width="thumbnailWidth || undefined"
                    :height="thumbnailHeight || undefined"
                    style="cursor:pointer"
                    alt=""
                    @click="onShowVideo"
                    ref="thumbnail"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {AspectRationHelper} from "../helpers/AspectRationHelper";
import {Listeners} from "../constants/listeners";
import {nextTick} from "vue";
import AdaptersLoader from "./adapters/Loader.vue";

export default {
    name: "RuTubeEmbed",
    props: {
        video: {
            type: String,
            required: true,
        },
        thumbnail: {
            type: String,
            required: false,
            default: null
        },
        thumbnailWidth: {
            type: Number,
            required: false,
            default: null,
        },
        thumbnailHeight: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            isShowVideo: false,
            width: null,
            height: null,
            isLoaded: false,
            imageLoaded: false,
            iframeLoading: false,
        }
    },
    created() {
        window.addEventListener('resize', () => this.recalcSize());
        this.$emitter.on(Listeners.RUTUBE_EMBED_PAUSE, () => this.onPause());
        this.$emitter.on(Listeners.RUTUBE_EMBED_PLAY, videoId => {
            if (videoId === this.getVideoId && this.isShowVideo) {
                this.recalcSize();
                this.onPlay();
            }
        });

        const self = this;
        window.addEventListener('message', function (event) {
            try {
                const message = JSON.parse(event.data);
                if (message.type === 'player:ready') {
                    self.$emitter.emit(Listeners.RUTUBE_EMBED_PLAY, message.data.videoId);
                }
            } catch (e) {
            }
        });
    },
    mounted() {
        this.recalcSize();
    },
    computed: {
        getThumbnailHeight() {
            return this.height;
        },
        getThumbnailWidth() {
            return this.width;
        },
        // вырезаем ID video из url
        getVideoId() {
            const url = URL.parse(this.video);
            const pathname = url.pathname.replace(/\/+$/, '');
            return pathname.substring(pathname.lastIndexOf('/') + 1);
        }
    },
    methods: {
        onLoadThumbnail() {
            this.recalcSize();
            this.imageLoaded = true;
        },
        recalcSize() {
            this.width = this.$refs.container.offsetWidth;
            this.height = AspectRationHelper.get16x9(this.$refs.container.offsetWidth);
        },
        onShowVideo() {
            this.isShowVideo = true;
            this.iframeLoading = true;
            this.$emitter.emit(Listeners.RUTUBE_EMBED_PAUSE);
        },
        onPause() {
            if (!this.$refs.video) {
                return;
            }
            this.$refs.video.contentWindow.postMessage(JSON.stringify({
                type: 'player:pause',
                data: {}
            }), '*');
        },
        onPlay() {
            nextTick(() => {
                if (!this.$refs.video) {
                    return;
                }
                const contentWindow = this.$refs.video.contentWindow;
                contentWindow.postMessage(JSON.stringify({
                    type: 'player:play',
                    data: {}
                }), '*');
                contentWindow.postMessage(JSON.stringify({
                    type: 'player:setVolume',
                    data: {
                        volume: 0.9//значение от 0 до 1
                    }
                }), '*');
            });
        },
    },
    components: {
        AdaptersLoader,
    },
}
</script>

<style scoped>
.rutube_embed__thumbnail {
    display: flex;
    align-items: center;
    max-width: 100%;
    max-height: 100%;
    justify-content: center;
}
.rutube_embed__thumbnail img {
    max-width: inherit;
    max-height: inherit;
    width: 100%;
    height: auto;
}
</style>
